'use client';

import React from 'react';

/**
 * Root-level error boundary. Minimal deps so it loads even when other chunks fail.
 * Does not import AppIcon or other app code.
 */
export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        backgroundColor: '#eeeced',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#236434', marginBottom: 8 }}>
        Something went wrong
      </h1>
      <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24, textAlign: 'center', maxWidth: 400 }}>
        This page encountered an error. Try again or go back.
      </p>
      <div style={{ display: 'flex', gap: 12 }}>
        <button
          type="button"
          onClick={() => reset()}
          style={{
            padding: '12px 24px',
            borderRadius: 8,
            border: 'none',
            backgroundColor: '#236434',
            color: 'white',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
        <button
          type="button"
          onClick={() => window.location.assign('/')}
          style={{
            padding: '12px 24px',
            borderRadius: 8,
            border: '1px solid #236434',
            backgroundColor: 'transparent',
            color: '#236434',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Go home
        </button>
      </div>
    </div>
  );
}
